import LabServiceModel from "@/models/LabServiceModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";
import LaboratoryModel from "@/models/lab/LaboratoryModel";
import TestPackageCollection from "../../collections/lab/TestPackageCollection";
import TestPackageSampleCollection from "../../collections/lab/TestPackageSampleCollection";

export default class TestPackageModel extends LabServiceModel {

  modelName() {
    return 'test-package';
  }

  defaults() {
    return {
      id: null,
      sample_type_id: null,
      sample_type: null,
      test_package_group_id: null,
      test_package_group: null,
      laboratory_id: null,
      laboratory: null,
      name: null,
      cost: null,
      cost_add_on: null,
      description: null,
      position: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      test_package_samples: [],
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      sample_type_id: (val) => (this.nullStringMutator(val)),
      sample_type: Object,
      test_package_group_id: (val) => (this.nullStringMutator(val)),
      test_package_group: Object,
      laboratory_id: (val) => (this.nullStringMutator(val)),
      laboratory: Object,
      name: (val) => (this.nullStringMutator(val)),
      cost: Number,
      cost_add_on: Boolean,
      description: (val) => (this.nullStringMutator(val)),
      position: Number,
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }

  // Attribute validation
  validation() {
    return {}
  }


  getSampleType() {
    return this.getRelatedModel(SampleTypeModel, 'sample_type');
  }

  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, 'laboratory');
  }

  getTestPackageSamples() {
    return this.getRelatedCollection((new TestPackageSampleCollection()), 'test_package_samples');
  }

}
